import { HOST, COMPLIANCE_DISCLOSURE, COPYRIGHT_LINE, CONTACT, ASSETS } from "../../content";
import { LuxBg } from "../Reveal";
import { Link } from "react-router-dom";

export const Footer = ({ disclosure = COMPLIANCE_DISCLOSURE, version = COPYRIGHT_LINE }) => (
  <footer className="relative border-t border-white/10 pt-24 pb-28 md:pb-16 px-6 sm:px-10 lg:px-16 xl:px-24 overflow-hidden" data-testid="footer-section">
    <LuxBg n={1} />
    <div
      className="absolute inset-x-0 bottom-0 text-center serif font-black uppercase whitespace-nowrap select-none pointer-events-none"
      style={{ fontSize: "14vw", color: "rgba(255,255,255,0.03)", lineHeight: 1 }}
      aria-hidden="true"
      data-testid="footer-wordmark"
    >
      REG — THE REAL ESTATE GUY
    </div>
    <div className="relative grid md:grid-cols-3 gap-12 mb-16">
      <div data-testid="footer-legal-col">
        <div className="mono text-[13px] tracking-[0.3em] text-[#FFC631] mb-5">LICENSING</div>
        <ul className="space-y-2 text-base text-white">
          <li>{HOST.name}</li>
          <li>{HOST.company}</li>
          <li>NMLS# {HOST.nmls}</li>
          <li>Company NMLS# {HOST.companyNmls}</li>
          <li>Licensed in {HOST.states}</li>
        </ul>
      </div>
      <div data-testid="footer-contact-col">
        <div className="mono text-[13px] tracking-[0.3em] text-[#FFC631] mb-5">CONTACT</div>
        <ul className="space-y-2 text-base">
          <li>
            <a href={`tel:${CONTACT.phoneTel}`} data-cta className="text-white hover:text-[#FE0000] transition-colors duration-200" data-testid="footer-phone">
              Phone: {CONTACT.phone}
            </a>
          </li>
          <li>
            <a href={`mailto:${CONTACT.email}`} data-cta className="text-white hover:text-[#FE0000] transition-colors duration-200" data-testid="footer-email">
              Email: {CONTACT.email}
            </a>
          </li>
        </ul>
      </div>
      <div data-testid="footer-links-col">
        <div className="mono text-[13px] tracking-[0.3em] text-[#FFC631] mb-5">LEGAL</div>
        <ul className="space-y-2 text-base">
          <li>
            <Link to="/privacy" data-cta className="text-white hover:text-[#FE0000] transition-colors duration-200" data-testid="footer-privacy-link">
              Privacy Policy
            </Link>
          </li>
          <li>
            <Link to="/terms" data-cta className="text-white hover:text-[#FE0000] transition-colors duration-200" data-testid="footer-terms-link">
              Terms &amp; Conditions
            </Link>
          </li>
        </ul>
        <div className="flex items-center gap-3 mt-8">
          <img src={ASSETS.usl1} alt="U.S. 1st Realty Partner" className="h-24 w-24 object-contain rounded-lg bg-white p-1" data-testid="footer-usl1-logo" />
          <img src={ASSETS.usl2} alt="U.S. Lending Partner — Your Lender for Life" className="h-24 w-24 object-contain rounded-lg bg-white p-1" data-testid="footer-usl2-logo" />
          <div className="h-24 w-24 rounded-lg bg-white p-2 flex flex-col items-center justify-center text-black shrink-0" data-testid="footer-ehl-logo">
            <svg viewBox="0 0 100 74" className="w-11 h-11" aria-hidden="true">
              <path d="M50 2 L98 36 H86 V72 H14 V36 H2 Z" fill="black" />
              <rect x="31" y="42" width="38" height="7" fill="white" />
              <rect x="31" y="56" width="38" height="7" fill="white" />
            </svg>
            <div className="text-[7px] font-bold tracking-tight text-center leading-tight mt-1.5">
              EQUAL HOUSING
              <br />
              LENDER
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="relative border-t border-white/10 pt-8">
      <p className="text-[14px] text-white leading-relaxed max-w-3xl" data-testid="footer-compliance">
        <span className="text-base mr-2" aria-label="Equal Housing Opportunity">⌂</span>
        {disclosure}
      </p>
      <p className="mono text-[13px] text-white mt-6 tracking-widest" data-testid="footer-copyright">{version}</p>
    </div>
  </footer>
);
